import React, { useContext, useCallback } from 'react';

// DEPENDENCIES
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL HELPERS
import { RecordContext } from 'helpers/getRecordData';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Card from 'parts/card/Card';
import Record from 'parts/record/Record';

// LOCAL PARTS
import AcitivtyLog from './parts/ActivityLog';

// VARIABLES
const ITEM_CONSTRUCTOR = () => ({
  email_address: '',
  full_name: ''
});

// MAIN COMPONENT
const EmailSettingUpdate = () => (
  <Record.Update
    recordLabel="email setting"
    endpoints={ENDPOINTS.admin.emailSettings}
    formatRecord={({ is_active, recipients } = {}) => ({
      is_active,
      email_recipients: recipients,
      delete_email_recipients: []
    })}
    deleteButton={false}
  >
    <Card body={<FormBody />} />
  </Record.Update>
);

// CHILD COMPONENT
const FormBody = () => {
  // CONTEXT
  const { record = {} } = useContext(RecordContext);

  // FORMIK
  const { values, setFieldValue } = useFormikContext() || {};

  // CALLBACKS
  const handleDelete = useCallback(
    item => {
      if (item) {
        setFieldValue('delete_email_recipients', [...values?.delete_email_recipients, item.dealer_email_recipient_id]);
      } else return false;
    },
    [values, setFieldValue]
  );

  // RENDER
  return (
    <Form.Body>
      <Form.PlainText label="Template Name" value={record.dealer_email_setting_type_name} />
      <Form.PlainText label="Description" value={record.dealer_email_setting_type_description} />
      <Form.YesNo
        name="is_active"
        label="Active"
        formGroup={{
          className: 'py-0'
        }}
        required
      />
      <Card.Divider />
      <Form.Table
        name="email_recipients"
        title="Email Recipients"
        itemLabel="Email Recipient"
        handleDelete={handleDelete}
        itemConstructor={ITEM_CONSTRUCTOR}
        buttonBefore
      >
        <Form.Control name="email_address" label="Email" schema="email" colWidth={12} required />
        <Form.Control name="full_name" label="Name" colWidth={12} />
      </Form.Table>
      {record.activity_log?.length && (
        <>
          <Card.Divider />
          <Form.Col>
            <AcitivtyLog />
          </Form.Col>
        </>
      )}
    </Form.Body>
  );
};

// EXPORT
export default EmailSettingUpdate;
